<ul class="validation-errors">
  <li *ngFor="let error of errors | keyvalue">
    {{ errorMessages[error.key] }}
  </li>
  <li *ngIf="customSingleErrorMessage.length > 0">
    {{ customSingleErrorMessage }}
  </li>
</ul>
